var map = {
	"./Xmas/img/arrow_down.svg": "99fd",
	"./Xmas/img/news-bg-btn.svg": "2dd6",
	"./Xmas/img/title_bg.svg": "b795",
	"./images/icon_bitoin.svg": "37e1",
	"./images/icon_chat.svg": "a357",
	"./images/icon_deposit.svg": "8696",
	"./images/icon_fb.svg": "37a3",
	"./images/icon_ig.svg": "336d",
	"./images/icon_tg.svg": "c202",
	"./images/icon_transfer.svg": "332a",
	"./images/icon_twitter.svg": "1866",
	"./images/icon_withdrawal.svg": "6d45",
	"./images/icon_youtube.svg": "de94",
	"./images/icon_zalo.svg": "f5e3",
	"./images/img_app.svg": "0e6a",
	"./images/img_app_download.svg": "6af4",
	"./images/img_app_hover.svg": "48ad",
	"./images/img_bell.svg": "0555",
	"./images/img_comingsoon.svg": "a559",
	"./images/img_en.svg": "099e",
	"./images/img_footer_logo.svg": "fc4f",
	"./images/img_logo.svg": "411b",
	"./images/img_offers.svg": "a030",
	"./images/img_plan.svg": "4590",
	"./images/img_ring.svg": "30ec",
	"./images/img_upload.svg": "b817",
	"./images/img_zh.svg": "dcb3",
	"./images/letter/img_bell.svg": "2b14",
	"./images/letter/img_ring.svg": "9c74",
	"./images/logo/logo.svg": "ed29",
	"./images/nav/icon_nav_gift.svg": "0616",
	"./images/nav/icon_nav_gift_hover.svg": "4184",
	"./images/nav/icon_nav_home.svg": "a8e8",
	"./images/nav/icon_nav_home_hover.svg": "d898",
	"./images/nav/icon_nav_more.svg": "0ba8",
	"./images/nav/icon_nav_more_hover.svg": "4a37",
	"./images/nav/icon_nav_msg.svg": "6189",
	"./images/nav/icon_nav_msg_hover.svg": "dd39",
	"./images/nav/icon_nav_topup.svg": "8f4a",
	"./images/nav/icon_nav_topup_hover.svg": "3749",
	"./images/upload/_img_arrow_right.svg": "53df",
	"./images/upload/img_app.svg": "ef41",
	"./images/upload/img_app_download.svg": "9371",
	"./images/upload/img_app_download_hover.svg": "aaaa",
	"./images/upload/img_app_hover.svg": "6758",
	"./images/upload/img_arrow_left.svg": "b29f",
	"./images/upload/img_arrow_right.svg": "7488",
	"./images/upload/img_auto-w.svg": "b3b4",
	"./images/upload/img_auto.svg": "f169",
	"./images/upload/img_brand_1.svg": "1e48",
	"./images/upload/img_brand_2.svg": "de5a",
	"./images/upload/img_brand_3.svg": "c79a",
	"./images/upload/img_brand_hover_1.svg": "c85c",
	"./images/upload/img_brand_hover_2.svg": "9eab",
	"./images/upload/img_brand_hover_3.svg": "078b",
	"./images/upload/img_chat.svg": "ed9c",
	"./images/upload/img_chat_hover.svg": "e85e",
	"./images/upload/img_chat_room.svg": "11c7",
	"./images/upload/img_crown.svg": "4ba0",
	"./images/upload/img_crown_hover.svg": "5e32",
	"./images/upload/img_date.svg": "afdc",
	"./images/upload/img_left_nav_bank.svg": "3826",
	"./images/upload/img_left_nav_bank_hover.svg": "d958",
	"./images/upload/img_left_nav_bet.svg": "96bc",
	"./images/upload/img_left_nav_bet_hover.svg": "5d7d",
	"./images/upload/img_left_nav_bonus.svg": "80b9",
	"./images/upload/img_left_nav_bonus_hover.svg": "e3b5",
	"./images/upload/img_left_nav_cooperate.svg": "ae47",
	"./images/upload/img_left_nav_cooperate_hover.svg": "b16e",
	"./images/upload/img_left_nav_detail.svg": "3986",
	"./images/upload/img_left_nav_detail_hover.svg": "1fcf",
	"./images/upload/img_left_nav_money.svg": "1f5d",
	"./images/upload/img_left_nav_money_hover.svg": "5255",
	"./images/upload/img_left_nav_notify.svg": "a827",
	"./images/upload/img_left_nav_notify_hover.svg": "cb41",
	"./images/upload/img_left_nav_person.svg": "2983",
	"./images/upload/img_left_nav_person_hover.svg": "054b",
	"./images/upload/img_left_nav_realtime.svg": "07ec",
	"./images/upload/img_left_nav_realtime_hover.svg": "c804",
	"./images/upload/img_left_nav_recommend.svg": "8b01",
	"./images/upload/img_left_nav_recommend_hover.svg": "7bce",
	"./images/upload/img_left_nav_sale.svg": "ac7a",
	"./images/upload/img_left_nav_sale_hover.svg": "f8fa",
	"./images/upload/img_left_nav_vip.svg": "88d7",
	"./images/upload/img_left_nav_vip_hover.svg": "9fef",
	"./images/upload/img_live.svg": "fe1b",
	"./images/upload/img_live_hover.svg": "a63e",
	"./images/upload/img_nav_bank-w.svg": "3de9",
	"./images/upload/img_nav_bank.svg": "cd6e",
	"./images/upload/img_nav_bank_hover.svg": "be2f",
	"./images/upload/img_nav_bet-w.svg": "f405",
	"./images/upload/img_nav_bet.svg": "77c7",
	"./images/upload/img_nav_bet_hover.svg": "bacd",
	"./images/upload/img_nav_bonus-w.svg": "9ee2",
	"./images/upload/img_nav_bonus.svg": "0a5d",
	"./images/upload/img_nav_bonus_hover.svg": "0b7d",
	"./images/upload/img_nav_cooperate-w.svg": "641e",
	"./images/upload/img_nav_cooperate.svg": "ff04",
	"./images/upload/img_nav_cooperate_hover.svg": "5376",
	"./images/upload/img_nav_detail-w.svg": "85a7",
	"./images/upload/img_nav_detail.svg": "8161",
	"./images/upload/img_nav_detail_hover.svg": "eb65",
	"./images/upload/img_nav_lang-w.svg": "775b",
	"./images/upload/img_nav_lang.svg": "feef",
	"./images/upload/img_nav_lang_hover.svg": "0771",
	"./images/upload/img_nav_logout-w.svg": "baad",
	"./images/upload/img_nav_logout.svg": "adb9",
	"./images/upload/img_nav_logout_hover.svg": "dc0e",
	"./images/upload/img_nav_money-w.svg": "502d",
	"./images/upload/img_nav_money.svg": "85b1",
	"./images/upload/img_nav_money_hover.svg": "b5ad",
	"./images/upload/img_nav_notify-w.svg": "aa11",
	"./images/upload/img_nav_notify.svg": "8250",
	"./images/upload/img_nav_notify_hover.svg": "46c9",
	"./images/upload/img_nav_person-w.svg": "06f3",
	"./images/upload/img_nav_person.svg": "504b",
	"./images/upload/img_nav_person_hover.svg": "35ac",
	"./images/upload/img_nav_realtime-w.svg": "6d09",
	"./images/upload/img_nav_realtime.svg": "0f6c",
	"./images/upload/img_nav_realtime_hover.svg": "7cc6",
	"./images/upload/img_nav_recommend-w.svg": "6f9c",
	"./images/upload/img_nav_recommend.svg": "4f6b",
	"./images/upload/img_nav_recommend_hover.svg": "8660",
	"./images/upload/img_nav_sale-w.svg": "45c5",
	"./images/upload/img_nav_sale.svg": "f6f9",
	"./images/upload/img_nav_sale_hover.svg": "aa7a",
	"./images/upload/img_nav_service-w.svg": "4bb9",
	"./images/upload/img_nav_service.svg": "a39d",
	"./images/upload/img_nav_vip-w.svg": "cab4",
	"./images/upload/img_nav_vip.svg": "1955",
	"./images/upload/img_nav_vip_hover.svg": "55e3",
	"./images/upload/img_plan.svg": "542c",
	"./images/upload/img_plan_hover.svg": "2e22",
	"./images/upload/img_quick.svg": "fb08",
	"./images/upload/img_quick_hover.svg": "6774",
	"./images/upload/img_realtime.svg": "1085",
	"./images/upload/img_realtime_hover.svg": "d7d0",
	"./images/upload/img_roll.svg": "37f8",
	"./images/upload/img_roll_hover.svg": "e71b",
	"./images/upload/img_sale.svg": "f0b7",
	"./images/upload/img_sale_hover.svg": "a133",
	"./images/upload/img_service.svg": "92a0",
	"./images/upload/img_service_hover.svg": "3b96",
	"./images/upload/img_wallet-w.svg": "ee99",
	"./images/upload/img_wallet.svg": "bafb",
	"./images/upload/img_wallet_nav.svg": "843c",
	"./images/upload/quick_chat.svg": "ad09",
	"./img/arrow-down.svg": "2e6e",
	"./img/arrow-downn.svg": "8050",
	"./img/arrow-right.svg": "3f8a",
	"./img/chat/basketball_on.svg": "afb9",
	"./img/chat/ping-pong_on.svg": "b7b1",
	"./img/chat/soccer_on.svg": "c0a0",
	"./img/checkbox_checked.svg": "e985",
	"./img/checkbox_default.svg": "1829",
	"./img/flow_chat-now.svg": "7bbb",
	"./img/flow_chat-now_hover.svg": "9b92",
	"./img/flow_customer-service.svg": "3f89",
	"./img/flow_customer-service_hover.svg": "6af2",
	"./img/flow_get-app.svg": "f445",
	"./img/flow_get-app_hover.svg": "f228",
	"./img/header-co.svg": "bee0",
	"./img/header-discount.svg": "f249",
	"./img/header-rebate.svg": "a106",
	"./img/header-vip.svg": "e3a3",
	"./img/icon_calendar.svg": "2a0f",
	"./img/icon_download.svg": "698f",
	"./img/icon_play.svg": "39cd",
	"./img/index/float-btn-cockfigh.svg": "a452",
	"./img/index/float-btn-esports.svg": "4aa6",
	"./img/index/float-btn-fish.svg": "1607",
	"./img/index/float-btn-live.svg": "0934",
	"./img/index/float-btn-lottery.svg": "0e8d",
	"./img/index/float-btn-poker.svg": "c38c",
	"./img/index/float-btn-slot.svg": "b849",
	"./img/index/float-btn-sports.svg": "6e91",
	"./img/mobile/customer-service.svg": "f0ef",
	"./img/mobile/tabbar/chat_off.svg": "5e0c",
	"./img/mobile/tabbar/chat_on.svg": "279f",
	"./img/mobile/tabbar/discount_off.svg": "da37",
	"./img/mobile/tabbar/discount_on.svg": "1c85",
	"./img/mobile/tabbar/home_off.svg": "8798",
	"./img/mobile/tabbar/home_on.svg": "ab7f",
	"./img/mobile/tabbar/more_off.svg": "31f0",
	"./img/mobile/tabbar/more_on.svg": "4f19",
	"./img/mobile/tabbar/topup_off.svg": "74b7",
	"./img/mobile/tabbar/topup_on.svg": "ceab",
	"./img/model_provider_arrow-o.svg": "4d9a",
	"./img/model_provider_arrow.svg": "5b1e",
	"./img/notion.svg": "83c5",
	"./img/personal_deposit.svg": "6380",
	"./img/provider/arrow_back.svg": "ec8c",
	"./img/provider/chicken.svg": "afb4",
	"./img/provider/fishing.svg": "dfa4",
	"./img/provider/live.svg": "a0cb",
	"./img/provider/poker.svg": "5ad3",
	"./img/provider/provider_bingo.svg": "5eb3",
	"./img/provider/provider_championship.svg": "1763",
	"./img/provider/provider_fishing.svg": "4ad7",
	"./img/provider/provider_new_games.svg": "391c",
	"./img/provider/provider_poker.svg": "7078",
	"./img/provider/provider_providers.svg": "0fbf",
	"./img/provider/provider_providers_mobile.svg": "9fc2",
	"./img/provider/provider_slot.svg": "ea8a",
	"./img/provider/provider_top.svg": "7c9a",
	"./img/provider/slot.svg": "a37d",
	"./img/provider/sports.svg": "d16d",
	"./img/provider_arrow.svg": "cdc9",
	"./img/provider_instantwins.svg": "cb0b",
	"./img/provider_jackpot.svg": "0068",
	"./img/provider_livecasino.svg": "21ab",
	"./img/provider_newgames.svg": "f326",
	"./img/provider_search.svg": "733c",
	"./img/provider_slots.svg": "15b2",
	"./img/provider_toprated.svg": "77a4",
	"./img/register_icon__personal.svg": "6d22",
	"./img/register_icon_key.svg": "ea7c",
	"./img/shortcut_app_off.svg": "8dd6",
	"./img/shortcut_chat_off.svg": "d9f0",
	"./img/shortcut_net_off.svg": "e9aa",
	"./img/shortcut_service_off.svg": "9616",
	"./img/shortcut_toff_off.svg": "85ab",
	"./thanksGiving/img/arrow_down.svg": "c84b",
	"./thanksGiving/img/title_bg.svg": "f2cf",
	"./theme1/images/icon_bitoin.svg": "e408",
	"./theme1/images/icon_chat.svg": "9c86",
	"./theme1/images/icon_deposit.svg": "aca8",
	"./theme1/images/icon_fb.svg": "a11d",
	"./theme1/images/icon_ig.svg": "82d8",
	"./theme1/images/icon_transfer.svg": "88bc",
	"./theme1/images/icon_twitter.svg": "cdea",
	"./theme1/images/icon_withdrawal.svg": "72c3",
	"./theme1/images/icon_youtube.svg": "b835",
	"./theme1/images/img_bell.svg": "b995",
	"./theme1/images/img_comingsoon.svg": "2612",
	"./theme1/images/img_en.svg": "e479",
	"./theme1/images/img_footer_logo.svg": "fa5c",
	"./theme1/images/img_logo.svg": "c248",
	"./theme1/images/img_offers.svg": "710e",
	"./theme1/images/img_plan.svg": "2aba",
	"./theme1/images/img_ring.svg": "6aae",
	"./theme1/images/img_upload.svg": "92dd",
	"./theme1/images/img_zh.svg": "0fb1",
	"./theme1/images/letter/img_bell.svg": "4857",
	"./theme1/images/letter/img_ring.svg": "e0d7",
	"./theme1/images/logo/logo.svg": "a8c0",
	"./theme1/images/nav/icon_nav_gift.svg": "f6dc",
	"./theme1/images/nav/icon_nav_gift_hover.svg": "86fb",
	"./theme1/images/nav/icon_nav_home.svg": "f7f2",
	"./theme1/images/nav/icon_nav_home_hover.svg": "2ece",
	"./theme1/images/nav/icon_nav_more.svg": "e87a",
	"./theme1/images/nav/icon_nav_more_hover.svg": "ba66",
	"./theme1/images/nav/icon_nav_msg.svg": "da86",
	"./theme1/images/nav/icon_nav_msg_hover.svg": "d2a3",
	"./theme1/images/nav/icon_nav_topup.svg": "ac26",
	"./theme1/images/nav/icon_nav_topup_hover.svg": "df58",
	"./theme1/images/upload/_img_arrow_right.svg": "f705",
	"./theme1/images/upload/img_app.svg": "658e",
	"./theme1/images/upload/img_app_download.svg": "aa01",
	"./theme1/images/upload/img_app_download_hover.svg": "6f70",
	"./theme1/images/upload/img_app_hover.svg": "eea4",
	"./theme1/images/upload/img_arrow_left.svg": "7d73",
	"./theme1/images/upload/img_arrow_right.svg": "5467",
	"./theme1/images/upload/img_auto-w.svg": "dce2",
	"./theme1/images/upload/img_auto.svg": "1a5c",
	"./theme1/images/upload/img_brand_1.svg": "7c24",
	"./theme1/images/upload/img_brand_2.svg": "21c8",
	"./theme1/images/upload/img_brand_3.svg": "3698",
	"./theme1/images/upload/img_brand_hover_1.svg": "080c",
	"./theme1/images/upload/img_brand_hover_2.svg": "2c83",
	"./theme1/images/upload/img_brand_hover_3.svg": "a657",
	"./theme1/images/upload/img_chat.svg": "410f",
	"./theme1/images/upload/img_chat_hover.svg": "01e8",
	"./theme1/images/upload/img_crown.svg": "2468",
	"./theme1/images/upload/img_crown_hover.svg": "41ea",
	"./theme1/images/upload/img_date.svg": "dbf5",
	"./theme1/images/upload/img_left_nav_bank.svg": "5758",
	"./theme1/images/upload/img_left_nav_bank_hover.svg": "6a3a",
	"./theme1/images/upload/img_left_nav_bet.svg": "1986",
	"./theme1/images/upload/img_left_nav_bet_hover.svg": "4222",
	"./theme1/images/upload/img_left_nav_bonus.svg": "49f2",
	"./theme1/images/upload/img_left_nav_bonus_hover.svg": "bb6a",
	"./theme1/images/upload/img_left_nav_cooperate.svg": "333c",
	"./theme1/images/upload/img_left_nav_cooperate_hover.svg": "2c3e",
	"./theme1/images/upload/img_left_nav_detail.svg": "ff56",
	"./theme1/images/upload/img_left_nav_detail_hover.svg": "d035",
	"./theme1/images/upload/img_left_nav_money.svg": "cd52",
	"./theme1/images/upload/img_left_nav_money_hover.svg": "1742",
	"./theme1/images/upload/img_left_nav_notify.svg": "82f4",
	"./theme1/images/upload/img_left_nav_notify_hover.svg": "3e4a",
	"./theme1/images/upload/img_left_nav_person.svg": "4fe9",
	"./theme1/images/upload/img_left_nav_person_hover.svg": "db0c",
	"./theme1/images/upload/img_left_nav_realtime.svg": "ba39",
	"./theme1/images/upload/img_left_nav_realtime_hover.svg": "a4b5",
	"./theme1/images/upload/img_left_nav_recommend.svg": "16aa",
	"./theme1/images/upload/img_left_nav_recommend_hover.svg": "fd16",
	"./theme1/images/upload/img_left_nav_sale.svg": "5163",
	"./theme1/images/upload/img_left_nav_sale_hover.svg": "93ea",
	"./theme1/images/upload/img_left_nav_vip.svg": "e5cd",
	"./theme1/images/upload/img_left_nav_vip_hover.svg": "96e5",
	"./theme1/images/upload/img_live.svg": "0d5b",
	"./theme1/images/upload/img_live_hover.svg": "8d2b",
	"./theme1/images/upload/img_nav_bank-w.svg": "3546",
	"./theme1/images/upload/img_nav_bank.svg": "2db2",
	"./theme1/images/upload/img_nav_bank_hover.svg": "aba0",
	"./theme1/images/upload/img_nav_bet-w.svg": "fd4b",
	"./theme1/images/upload/img_nav_bet.svg": "1b7b",
	"./theme1/images/upload/img_nav_bet_hover.svg": "3628",
	"./theme1/images/upload/img_nav_bonus-w.svg": "dc76",
	"./theme1/images/upload/img_nav_bonus.svg": "18e7",
	"./theme1/images/upload/img_nav_bonus_hover.svg": "d4d1",
	"./theme1/images/upload/img_nav_cooperate-w.svg": "fd7d",
	"./theme1/images/upload/img_nav_cooperate.svg": "1783",
	"./theme1/images/upload/img_nav_cooperate_hover.svg": "2ff3",
	"./theme1/images/upload/img_nav_detail-w.svg": "8379",
	"./theme1/images/upload/img_nav_detail.svg": "4682",
	"./theme1/images/upload/img_nav_detail_hover.svg": "f6b46",
	"./theme1/images/upload/img_nav_lang-w.svg": "1a28",
	"./theme1/images/upload/img_nav_lang.svg": "00e4",
	"./theme1/images/upload/img_nav_lang_hover.svg": "6f30",
	"./theme1/images/upload/img_nav_logout-w.svg": "9186",
	"./theme1/images/upload/img_nav_logout.svg": "ab26",
	"./theme1/images/upload/img_nav_logout_hover.svg": "ead5",
	"./theme1/images/upload/img_nav_money-w.svg": "8b41",
	"./theme1/images/upload/img_nav_money.svg": "6296",
	"./theme1/images/upload/img_nav_money_hover.svg": "9e6e",
	"./theme1/images/upload/img_nav_notify-w.svg": "a57d",
	"./theme1/images/upload/img_nav_notify.svg": "790d",
	"./theme1/images/upload/img_nav_notify_hover.svg": "6081",
	"./theme1/images/upload/img_nav_person-w.svg": "baab",
	"./theme1/images/upload/img_nav_person.svg": "ed8e",
	"./theme1/images/upload/img_nav_person_hover.svg": "14d3",
	"./theme1/images/upload/img_nav_realtime-w.svg": "55d4",
	"./theme1/images/upload/img_nav_realtime.svg": "2a3a",
	"./theme1/images/upload/img_nav_realtime_hover.svg": "f836",
	"./theme1/images/upload/img_nav_recommend-w.svg": "088e",
	"./theme1/images/upload/img_nav_recommend.svg": "c749",
	"./theme1/images/upload/img_nav_recommend_hover.svg": "a63a",
	"./theme1/images/upload/img_nav_sale-w.svg": "c0ab",
	"./theme1/images/upload/img_nav_sale.svg": "71a8",
	"./theme1/images/upload/img_nav_sale_hover.svg": "4b39",
	"./theme1/images/upload/img_nav_service-w.svg": "4cdc",
	"./theme1/images/upload/img_nav_service.svg": "00e5",
	"./theme1/images/upload/img_nav_vip-w.svg": "1968",
	"./theme1/images/upload/img_nav_vip.svg": "0349",
	"./theme1/images/upload/img_nav_vip_hover.svg": "5bf9",
	"./theme1/images/upload/img_plan.svg": "fe44",
	"./theme1/images/upload/img_plan_hover.svg": "e2af",
	"./theme1/images/upload/img_quick.svg": "9d64",
	"./theme1/images/upload/img_quick_hover.svg": "e231",
	"./theme1/images/upload/img_realtime.svg": "642c",
	"./theme1/images/upload/img_realtime_hover.svg": "15ef",
	"./theme1/images/upload/img_roll.svg": "6bd4",
	"./theme1/images/upload/img_roll_hover.svg": "eea9",
	"./theme1/images/upload/img_sale.svg": "562e",
	"./theme1/images/upload/img_sale_hover.svg": "d167",
	"./theme1/images/upload/img_service.svg": "a138",
	"./theme1/images/upload/img_service_hover.svg": "cefb",
	"./theme1/images/upload/img_wallet-w.svg": "f9e6",
	"./theme1/images/upload/img_wallet.svg": "333a",
	"./theme1/images/upload/img_wallet_nav.svg": "0ecd",
	"./theme1/img/arrow-down.svg": "36a2",
	"./theme1/img/chat/basketball_on.svg": "ff07",
	"./theme1/img/chat/ping-pong_on.svg": "2816",
	"./theme1/img/chat/soccer_on.svg": "38c8",
	"./theme1/img/header-co.svg": "92f8",
	"./theme1/img/header-discount.svg": "2284",
	"./theme1/img/header-rebate.svg": "b6c7",
	"./theme1/img/header-vip.svg": "87a6",
	"./theme1/img/icon_calendar.svg": "5a0e",
	"./theme1/img/icon_play.svg": "9667",
	"./theme1/img/index/float-btn-cockfigh.svg": "bde6",
	"./theme1/img/index/float-btn-esports.svg": "97e0",
	"./theme1/img/index/float-btn-fish.svg": "95e0",
	"./theme1/img/index/float-btn-live.svg": "9d21",
	"./theme1/img/index/float-btn-lottery.svg": "343c",
	"./theme1/img/index/float-btn-poker.svg": "243d",
	"./theme1/img/index/float-btn-slot.svg": "7b96",
	"./theme1/img/index/float-btn-sports.svg": "880c",
	"./theme1/img/mobile/customer-service.svg": "4474",
	"./theme1/img/mobile/tabbar/chat_off.svg": "6197",
	"./theme1/img/mobile/tabbar/chat_on.svg": "efda",
	"./theme1/img/mobile/tabbar/discount_off.svg": "5d46",
	"./theme1/img/mobile/tabbar/discount_on.svg": "a4b7",
	"./theme1/img/mobile/tabbar/home_off.svg": "0987",
	"./theme1/img/mobile/tabbar/home_on.svg": "1c82",
	"./theme1/img/mobile/tabbar/more_off.svg": "ebee",
	"./theme1/img/mobile/tabbar/more_on.svg": "c8b0",
	"./theme1/img/mobile/tabbar/topup_off.svg": "bf86",
	"./theme1/img/mobile/tabbar/topup_on.svg": "2bbe",
	"./theme1/img/shortcut_app_off.svg": "0dbf",
	"./theme1/img/shortcut_chat_off.svg": "1d48",
	"./theme1/img/shortcut_net_off.svg": "a2b3",
	"./theme1/img/shortcut_service_off.svg": "259d",
	"./theme1/img/shortcut_toff_off.svg": "a934",
	"./theme2/images/icon_bitoin.svg": "85ca",
	"./theme2/images/icon_chat.svg": "0572",
	"./theme2/images/icon_deposit.svg": "78dc",
	"./theme2/images/icon_fb.svg": "7a0e",
	"./theme2/images/icon_ig.svg": "4ec3",
	"./theme2/images/icon_transfer.svg": "3c0a",
	"./theme2/images/icon_twitter.svg": "be06",
	"./theme2/images/icon_withdrawal.svg": "ba15",
	"./theme2/images/icon_youtube.svg": "1fc1",
	"./theme2/images/img_bell.svg": "f890",
	"./theme2/images/img_comingsoon.svg": "0388",
	"./theme2/images/img_en.svg": "2b45",
	"./theme2/images/img_footer_logo.svg": "09a0",
	"./theme2/images/img_logo.svg": "f0a7",
	"./theme2/images/img_offers.svg": "a51c",
	"./theme2/images/img_plan.svg": "1356",
	"./theme2/images/img_ring.svg": "50be",
	"./theme2/images/img_upload.svg": "c341",
	"./theme2/images/img_zh.svg": "0bdd",
	"./theme2/images/letter/img_bell.svg": "92c7",
	"./theme2/images/letter/img_ring.svg": "1c18",
	"./theme2/images/logo/logo.svg": "9bc8",
	"./theme2/images/nav/icon_nav_gift.svg": "5e52",
	"./theme2/images/nav/icon_nav_gift_hover.svg": "f9be",
	"./theme2/images/nav/icon_nav_home.svg": "08f1",
	"./theme2/images/nav/icon_nav_home_hover.svg": "e90a",
	"./theme2/images/nav/icon_nav_more.svg": "be55",
	"./theme2/images/nav/icon_nav_more_hover.svg": "5126",
	"./theme2/images/nav/icon_nav_msg.svg": "6e42",
	"./theme2/images/nav/icon_nav_msg_hover.svg": "89fc",
	"./theme2/images/nav/icon_nav_topup.svg": "e7db",
	"./theme2/images/nav/icon_nav_topup_hover.svg": "1cfb",
	"./theme2/images/upload/_img_arrow_right.svg": "adf3",
	"./theme2/images/upload/icon_deposit.svg": "4fef",
	"./theme2/images/upload/img_app.svg": "c86b",
	"./theme2/images/upload/img_app_download.svg": "7c5a",
	"./theme2/images/upload/img_app_download_hover.svg": "9bfc",
	"./theme2/images/upload/img_app_hover.svg": "071a",
	"./theme2/images/upload/img_arrow_left.svg": "156c",
	"./theme2/images/upload/img_arrow_right.svg": "4e16",
	"./theme2/images/upload/img_auto-w.svg": "f5e9",
	"./theme2/images/upload/img_auto.svg": "429e",
	"./theme2/images/upload/img_brand_1.svg": "d2e9",
	"./theme2/images/upload/img_brand_2.svg": "0866",
	"./theme2/images/upload/img_brand_3.svg": "da54",
	"./theme2/images/upload/img_brand_hover_1.svg": "d7d9",
	"./theme2/images/upload/img_brand_hover_2.svg": "9d58",
	"./theme2/images/upload/img_brand_hover_3.svg": "363f",
	"./theme2/images/upload/img_chat.svg": "1d85",
	"./theme2/images/upload/img_chat_hover.svg": "5072",
	"./theme2/images/upload/img_crown.svg": "b12b",
	"./theme2/images/upload/img_crown_hover.svg": "66f2",
	"./theme2/images/upload/img_date.svg": "d6ef",
	"./theme2/images/upload/img_left_nav_bank.svg": "48dd",
	"./theme2/images/upload/img_left_nav_bank_hover.svg": "215f",
	"./theme2/images/upload/img_left_nav_bet.svg": "92f6",
	"./theme2/images/upload/img_left_nav_bet_hover.svg": "8f96",
	"./theme2/images/upload/img_left_nav_bonus.svg": "021a",
	"./theme2/images/upload/img_left_nav_bonus_hover.svg": "23fa",
	"./theme2/images/upload/img_left_nav_cooperate.svg": "469b",
	"./theme2/images/upload/img_left_nav_cooperate_hover.svg": "1464",
	"./theme2/images/upload/img_left_nav_detail.svg": "f2fc",
	"./theme2/images/upload/img_left_nav_detail_hover.svg": "401a",
	"./theme2/images/upload/img_left_nav_money.svg": "df7d",
	"./theme2/images/upload/img_left_nav_money_hover.svg": "955c",
	"./theme2/images/upload/img_left_nav_notify.svg": "4881",
	"./theme2/images/upload/img_left_nav_notify_hover.svg": "63ae",
	"./theme2/images/upload/img_left_nav_person.svg": "465b",
	"./theme2/images/upload/img_left_nav_person_hover.svg": "2a6d",
	"./theme2/images/upload/img_left_nav_realtime.svg": "374f",
	"./theme2/images/upload/img_left_nav_realtime_hover.svg": "c385",
	"./theme2/images/upload/img_left_nav_recommend.svg": "2488",
	"./theme2/images/upload/img_left_nav_recommend_hover.svg": "44db",
	"./theme2/images/upload/img_left_nav_sale.svg": "5d9d",
	"./theme2/images/upload/img_left_nav_sale_hover.svg": "41e4",
	"./theme2/images/upload/img_left_nav_vip.svg": "3c25",
	"./theme2/images/upload/img_left_nav_vip_hover.svg": "9052",
	"./theme2/images/upload/img_live.svg": "64d0",
	"./theme2/images/upload/img_live_hover.svg": "7d45",
	"./theme2/images/upload/img_nav_bank-w.svg": "6dc0",
	"./theme2/images/upload/img_nav_bank.svg": "8196",
	"./theme2/images/upload/img_nav_bank_hover.svg": "2c26",
	"./theme2/images/upload/img_nav_bet-w.svg": "ab7fb",
	"./theme2/images/upload/img_nav_bet.svg": "972c",
	"./theme2/images/upload/img_nav_bet_hover.svg": "d568",
	"./theme2/images/upload/img_nav_bonus-w.svg": "7f4f",
	"./theme2/images/upload/img_nav_bonus.svg": "6abd",
	"./theme2/images/upload/img_nav_bonus_hover.svg": "f6f6",
	"./theme2/images/upload/img_nav_cooperate-w.svg": "e6c6",
	"./theme2/images/upload/img_nav_cooperate.svg": "4397",
	"./theme2/images/upload/img_nav_cooperate_hover.svg": "b3a6",
	"./theme2/images/upload/img_nav_detail-w.svg": "c5c0",
	"./theme2/images/upload/img_nav_detail.svg": "f4d4",
	"./theme2/images/upload/img_nav_detail_hover.svg": "e932",
	"./theme2/images/upload/img_nav_lang-w.svg": "7d92",
	"./theme2/images/upload/img_nav_lang.svg": "8366",
	"./theme2/images/upload/img_nav_lang_hover.svg": "6ab7",
	"./theme2/images/upload/img_nav_logout-w.svg": "a5ce",
	"./theme2/images/upload/img_nav_logout.svg": "e482",
	"./theme2/images/upload/img_nav_logout_hover.svg": "aa5f",
	"./theme2/images/upload/img_nav_money-w.svg": "154b",
	"./theme2/images/upload/img_nav_money.svg": "061c",
	"./theme2/images/upload/img_nav_money_hover.svg": "a769",
	"./theme2/images/upload/img_nav_notify-w.svg": "5625",
	"./theme2/images/upload/img_nav_notify.svg": "e54d",
	"./theme2/images/upload/img_nav_notify_hover.svg": "b0f8",
	"./theme2/images/upload/img_nav_person-w.svg": "67d5",
	"./theme2/images/upload/img_nav_person.svg": "95cd",
	"./theme2/images/upload/img_nav_person_hover.svg": "4ad2",
	"./theme2/images/upload/img_nav_realtime-w.svg": "0830",
	"./theme2/images/upload/img_nav_realtime.svg": "82c7",
	"./theme2/images/upload/img_nav_realtime_hover.svg": "6543",
	"./theme2/images/upload/img_nav_recommend-w.svg": "11d5",
	"./theme2/images/upload/img_nav_recommend.svg": "8cb1",
	"./theme2/images/upload/img_nav_recommend_hover.svg": "0f68",
	"./theme2/images/upload/img_nav_sale-w.svg": "5c14",
	"./theme2/images/upload/img_nav_sale.svg": "beb9",
	"./theme2/images/upload/img_nav_sale_hover.svg": "be19",
	"./theme2/images/upload/img_nav_service-w.svg": "4c67",
	"./theme2/images/upload/img_nav_service.svg": "5a55",
	"./theme2/images/upload/img_nav_vip-w.svg": "f649",
	"./theme2/images/upload/img_nav_vip.svg": "a505",
	"./theme2/images/upload/img_nav_vip_hover.svg": "6e86",
	"./theme2/images/upload/img_plan.svg": "cb35",
	"./theme2/images/upload/img_plan_hover.svg": "4c66",
	"./theme2/images/upload/img_quick.svg": "6460",
	"./theme2/images/upload/img_quick_hover.svg": "2f4f",
	"./theme2/images/upload/img_realtime.svg": "a038",
	"./theme2/images/upload/img_realtime_hover.svg": "63ef",
	"./theme2/images/upload/img_roll.svg": "9242",
	"./theme2/images/upload/img_roll_hover.svg": "e6df",
	"./theme2/images/upload/img_sale.svg": "974f",
	"./theme2/images/upload/img_sale_hover.svg": "fc13",
	"./theme2/images/upload/img_service.svg": "869a",
	"./theme2/images/upload/img_service_hover.svg": "d85d",
	"./theme2/images/upload/img_wallet-w.svg": "c5c7",
	"./theme2/images/upload/img_wallet.svg": "2e0f",
	"./theme2/images/upload/img_wallet_nav.svg": "298d",
	"./theme2/img/arrow-down.svg": "4aec",
	"./theme2/img/chat/basketball_on.svg": "b01c",
	"./theme2/img/chat/ping-pong_on.svg": "21eb",
	"./theme2/img/chat/soccer_on.svg": "71db",
	"./theme2/img/header-co.svg": "e83a",
	"./theme2/img/header-discount.svg": "8c9d",
	"./theme2/img/header-rebate.svg": "b434",
	"./theme2/img/header-vip.svg": "47ff",
	"./theme2/img/icon_calendar.svg": "cac2",
	"./theme2/img/icon_play.svg": "46bf",
	"./theme2/img/index/float-btn-cockfigh.svg": "99af8",
	"./theme2/img/index/float-btn-esports.svg": "5360",
	"./theme2/img/index/float-btn-fish.svg": "4c05",
	"./theme2/img/index/float-btn-live.svg": "cca5",
	"./theme2/img/index/float-btn-lottery.svg": "24d9",
	"./theme2/img/index/float-btn-poker.svg": "dcc7",
	"./theme2/img/index/float-btn-slot.svg": "9051",
	"./theme2/img/index/float-btn-sports.svg": "8e8b",
	"./theme2/img/mobile/customer-service.svg": "b766",
	"./theme2/img/mobile/tabbar/chat_off.svg": "c97c",
	"./theme2/img/mobile/tabbar/chat_on.svg": "95a0",
	"./theme2/img/mobile/tabbar/discount_off.svg": "e5d9",
	"./theme2/img/mobile/tabbar/discount_on.svg": "7d21",
	"./theme2/img/mobile/tabbar/home_off.svg": "1fbb",
	"./theme2/img/mobile/tabbar/home_on.svg": "ca90",
	"./theme2/img/mobile/tabbar/more_off.svg": "4cb8",
	"./theme2/img/mobile/tabbar/more_on.svg": "3702",
	"./theme2/img/mobile/tabbar/topup_off.svg": "d248",
	"./theme2/img/mobile/tabbar/topup_on.svg": "9394",
	"./theme2/img/shortcut_app_off.svg": "cab9",
	"./theme2/img/shortcut_chat_off.svg": "d1b0",
	"./theme2/img/shortcut_net_off.svg": "e8e6",
	"./theme2/img/shortcut_service_off.svg": "f981",
	"./theme2/img/shortcut_toff_off.svg": "2872",
	"./theme3/images/icon_bitoin.svg": "ae32",
	"./theme3/images/icon_chat.svg": "c741",
	"./theme3/images/icon_deposit.svg": "a671",
	"./theme3/images/icon_fb.svg": "2c08",
	"./theme3/images/icon_ig.svg": "a2ea",
	"./theme3/images/icon_transfer.svg": "ed4e",
	"./theme3/images/icon_twitter.svg": "12f8",
	"./theme3/images/icon_withdrawal.svg": "c552",
	"./theme3/images/icon_youtube.svg": "2233",
	"./theme3/images/img_bell.svg": "f7eb",
	"./theme3/images/img_comingsoon.svg": "31a6",
	"./theme3/images/img_en.svg": "8f6c",
	"./theme3/images/img_footer_logo.svg": "08a7",
	"./theme3/images/img_logo.svg": "5730",
	"./theme3/images/img_offers.svg": "5136",
	"./theme3/images/img_plan.svg": "93ae",
	"./theme3/images/img_ring.svg": "4d04",
	"./theme3/images/img_upload.svg": "ca5f",
	"./theme3/images/img_zh.svg": "dbd3",
	"./theme3/images/letter/img_bell.svg": "725e",
	"./theme3/images/letter/img_ring.svg": "4198",
	"./theme3/images/logo/logo.svg": "bfca",
	"./theme3/images/nav/icon_nav_gift.svg": "ec14",
	"./theme3/images/nav/icon_nav_gift_hover.svg": "2754",
	"./theme3/images/nav/icon_nav_home.svg": "de15",
	"./theme3/images/nav/icon_nav_home_hover.svg": "88d9",
	"./theme3/images/nav/icon_nav_more.svg": "2f3b",
	"./theme3/images/nav/icon_nav_more_hover.svg": "3f3a",
	"./theme3/images/nav/icon_nav_msg.svg": "aa6a",
	"./theme3/images/nav/icon_nav_msg_hover.svg": "b557",
	"./theme3/images/nav/icon_nav_topup.svg": "6b6a",
	"./theme3/images/nav/icon_nav_topup_hover.svg": "2790",
	"./theme3/images/upload/_img_arrow_right.svg": "2373",
	"./theme3/images/upload/icon_deposit.svg": "e603",
	"./theme3/images/upload/img_app.svg": "4afe",
	"./theme3/images/upload/img_app_download.svg": "795c",
	"./theme3/images/upload/img_app_download_hover.svg": "92eb",
	"./theme3/images/upload/img_app_hover.svg": "4689",
	"./theme3/images/upload/img_arrow_left.svg": "0433",
	"./theme3/images/upload/img_arrow_right.svg": "0548",
	"./theme3/images/upload/img_auto-w.svg": "40ed",
	"./theme3/images/upload/img_auto.svg": "c0b8",
	"./theme3/images/upload/img_brand_1.svg": "f24b",
	"./theme3/images/upload/img_brand_2.svg": "8ca0",
	"./theme3/images/upload/img_brand_3.svg": "fdc1",
	"./theme3/images/upload/img_brand_hover_1.svg": "9555",
	"./theme3/images/upload/img_brand_hover_2.svg": "09c7",
	"./theme3/images/upload/img_brand_hover_3.svg": "ae3f",
	"./theme3/images/upload/img_chat.svg": "6db2",
	"./theme3/images/upload/img_chat_hover.svg": "2769",
	"./theme3/images/upload/img_crown.svg": "131a",
	"./theme3/images/upload/img_crown_hover.svg": "ebd6",
	"./theme3/images/upload/img_date.svg": "96cd",
	"./theme3/images/upload/img_left_nav_bank.svg": "6c88",
	"./theme3/images/upload/img_left_nav_bank_hover.svg": "3414",
	"./theme3/images/upload/img_left_nav_bet.svg": "9f2d",
	"./theme3/images/upload/img_left_nav_bet_hover.svg": "ba91",
	"./theme3/images/upload/img_left_nav_bonus.svg": "9d97",
	"./theme3/images/upload/img_left_nav_bonus_hover.svg": "2326e",
	"./theme3/images/upload/img_left_nav_cooperate.svg": "0524",
	"./theme3/images/upload/img_left_nav_cooperate_hover.svg": "8ca8",
	"./theme3/images/upload/img_left_nav_detail.svg": "cd5f",
	"./theme3/images/upload/img_left_nav_detail_hover.svg": "195c",
	"./theme3/images/upload/img_left_nav_money.svg": "5c6f",
	"./theme3/images/upload/img_left_nav_money_hover.svg": "e01d",
	"./theme3/images/upload/img_left_nav_notify.svg": "2be1",
	"./theme3/images/upload/img_left_nav_notify_hover.svg": "8cad",
	"./theme3/images/upload/img_left_nav_person.svg": "b500",
	"./theme3/images/upload/img_left_nav_person_hover.svg": "3e9f",
	"./theme3/images/upload/img_left_nav_realtime.svg": "1c0f",
	"./theme3/images/upload/img_left_nav_realtime_hover.svg": "d86d",
	"./theme3/images/upload/img_left_nav_recommend.svg": "cb94",
	"./theme3/images/upload/img_left_nav_recommend_hover.svg": "508f",
	"./theme3/images/upload/img_left_nav_sale.svg": "6b3c",
	"./theme3/images/upload/img_left_nav_sale_hover.svg": "f0b8",
	"./theme3/images/upload/img_left_nav_vip.svg": "e33a",
	"./theme3/images/upload/img_left_nav_vip_hover.svg": "5706",
	"./theme3/images/upload/img_live.svg": "6429",
	"./theme3/images/upload/img_live_hover.svg": "42c1",
	"./theme3/images/upload/img_nav_bank-w.svg": "09a6",
	"./theme3/images/upload/img_nav_bank.svg": "a8e5",
	"./theme3/images/upload/img_nav_bank_hover.svg": "1a4e",
	"./theme3/images/upload/img_nav_bet-w.svg": "dc40",
	"./theme3/images/upload/img_nav_bet.svg": "c0a6",
	"./theme3/images/upload/img_nav_bet_hover.svg": "ce69",
	"./theme3/images/upload/img_nav_bonus-w.svg": "d49c",
	"./theme3/images/upload/img_nav_bonus.svg": "97d4",
	"./theme3/images/upload/img_nav_bonus_hover.svg": "ef09",
	"./theme3/images/upload/img_nav_cooperate-w.svg": "ada5",
	"./theme3/images/upload/img_nav_cooperate.svg": "ff91",
	"./theme3/images/upload/img_nav_cooperate_hover.svg": "0246",
	"./theme3/images/upload/img_nav_detail-w.svg": "1c2d",
	"./theme3/images/upload/img_nav_detail.svg": "5e44",
	"./theme3/images/upload/img_nav_detail_hover.svg": "0cd5",
	"./theme3/images/upload/img_nav_lang-w.svg": "f44d",
	"./theme3/images/upload/img_nav_lang.svg": "7b80",
	"./theme3/images/upload/img_nav_lang_hover.svg": "28ff",
	"./theme3/images/upload/img_nav_logout-w.svg": "0bff",
	"./theme3/images/upload/img_nav_logout.svg": "40b4",
	"./theme3/images/upload/img_nav_logout_hover.svg": "c0e6",
	"./theme3/images/upload/img_nav_money-w.svg": "c1ea",
	"./theme3/images/upload/img_nav_money.svg": "c0a4",
	"./theme3/images/upload/img_nav_money_hover.svg": "6575",
	"./theme3/images/upload/img_nav_notify-w.svg": "0c93",
	"./theme3/images/upload/img_nav_notify.svg": "5d04",
	"./theme3/images/upload/img_nav_notify_hover.svg": "4f4f",
	"./theme3/images/upload/img_nav_person-w.svg": "0877",
	"./theme3/images/upload/img_nav_person.svg": "682b",
	"./theme3/images/upload/img_nav_person_hover.svg": "a9bc",
	"./theme3/images/upload/img_nav_realtime-w.svg": "67e2",
	"./theme3/images/upload/img_nav_realtime.svg": "811b",
	"./theme3/images/upload/img_nav_realtime_hover.svg": "aa38",
	"./theme3/images/upload/img_nav_recommend-w.svg": "f7d9",
	"./theme3/images/upload/img_nav_recommend.svg": "15ce",
	"./theme3/images/upload/img_nav_recommend_hover.svg": "0e10",
	"./theme3/images/upload/img_nav_sale-w.svg": "4a0cc",
	"./theme3/images/upload/img_nav_sale.svg": "b002",
	"./theme3/images/upload/img_nav_sale_hover.svg": "0673",
	"./theme3/images/upload/img_nav_service-w.svg": "5001",
	"./theme3/images/upload/img_nav_service.svg": "c668",
	"./theme3/images/upload/img_nav_vip-w.svg": "c765",
	"./theme3/images/upload/img_nav_vip.svg": "1d57",
	"./theme3/images/upload/img_nav_vip_hover.svg": "f43a",
	"./theme3/images/upload/img_plan.svg": "a85e",
	"./theme3/images/upload/img_plan_hover.svg": "f9f5",
	"./theme3/images/upload/img_quick.svg": "6e06",
	"./theme3/images/upload/img_quick_hover.svg": "a731",
	"./theme3/images/upload/img_realtime.svg": "9c83",
	"./theme3/images/upload/img_realtime_hover.svg": "cfd8",
	"./theme3/images/upload/img_roll.svg": "6c4f",
	"./theme3/images/upload/img_roll_hover.svg": "160a",
	"./theme3/images/upload/img_sale.svg": "79d8",
	"./theme3/images/upload/img_sale_hover.svg": "6e3f",
	"./theme3/images/upload/img_service.svg": "cbcc",
	"./theme3/images/upload/img_service_hover.svg": "53b9",
	"./theme3/images/upload/img_wallet-w.svg": "ea4e",
	"./theme3/images/upload/img_wallet.svg": "2d61",
	"./theme3/images/upload/img_wallet_nav.svg": "6333",
	"./theme3/img/arrow-down.svg": "fb45",
	"./theme3/img/chat/basketball_on.svg": "1405",
	"./theme3/img/chat/ping-pong_on.svg": "9f55",
	"./theme3/img/chat/soccer_on.svg": "ca3b",
	"./theme3/img/header-co.svg": "9dba",
	"./theme3/img/header-discount.svg": "aa64",
	"./theme3/img/header-rebate.svg": "3772",
	"./theme3/img/header-vip.svg": "e5ef",
	"./theme3/img/icon_calendar.svg": "ebab",
	"./theme3/img/icon_play.svg": "559e",
	"./theme3/img/index/float-btn-cockfigh.svg": "57cc",
	"./theme3/img/index/float-btn-esports.svg": "fc12",
	"./theme3/img/index/float-btn-fish.svg": "8dc3",
	"./theme3/img/index/float-btn-live.svg": "211f",
	"./theme3/img/index/float-btn-lottery.svg": "9d7f",
	"./theme3/img/index/float-btn-poker.svg": "14c6",
	"./theme3/img/index/float-btn-slot.svg": "f95f",
	"./theme3/img/index/float-btn-sports.svg": "ea97",
	"./theme3/img/mobile/customer-service.svg": "f7d5",
	"./theme3/img/mobile/tabbar/chat_off.svg": "9c44",
	"./theme3/img/mobile/tabbar/chat_on.svg": "c25c",
	"./theme3/img/mobile/tabbar/discount_off.svg": "c8b1",
	"./theme3/img/mobile/tabbar/discount_on.svg": "3945",
	"./theme3/img/mobile/tabbar/home_off.svg": "b0c8",
	"./theme3/img/mobile/tabbar/home_on.svg": "9e2a",
	"./theme3/img/mobile/tabbar/more_off.svg": "d01b",
	"./theme3/img/mobile/tabbar/more_on.svg": "ff8b",
	"./theme3/img/mobile/tabbar/topup_off.svg": "12e7",
	"./theme3/img/mobile/tabbar/topup_on.svg": "d628",
	"./theme3/img/shortcut_app_off.svg": "e849",
	"./theme3/img/shortcut_chat_off.svg": "323e",
	"./theme3/img/shortcut_net_off.svg": "b128",
	"./theme3/img/shortcut_service_off.svg": "b285",
	"./theme3/img/shortcut_toff_off.svg": "ddb0",
	"./theme4/images/bg-image.svg": "ada8",
	"./theme4/images/bouns-blue-bg.svg": "c5324",
	"./theme4/images/bouns-gray-bg.svg": "ffa2",
	"./theme4/images/confirm-bg.svg": "da19",
	"./theme4/images/esport_icon.svg": "8062",
	"./theme4/images/fish_icon.svg": "ebd0",
	"./theme4/images/game_icon.svg": "49fe",
	"./theme4/images/icon-check-empty.svg": "76ab",
	"./theme4/images/icon_bitoin.svg": "0ad2",
	"./theme4/images/icon_chat.svg": "8e54",
	"./theme4/images/icon_deposit.svg": "6df8",
	"./theme4/images/icon_fb.svg": "afc9",
	"./theme4/images/icon_ig.svg": "83db",
	"./theme4/images/icon_transfer.svg": "ff30",
	"./theme4/images/icon_twitter.svg": "677e",
	"./theme4/images/icon_withdrawal.svg": "16b5",
	"./theme4/images/icon_youtube.svg": "e6ef",
	"./theme4/images/img_bell.svg": "56a9",
	"./theme4/images/img_comingsoon.svg": "074d",
	"./theme4/images/img_en.svg": "c34a",
	"./theme4/images/img_footer_logo.svg": "90a2",
	"./theme4/images/img_logo.svg": "0f58",
	"./theme4/images/img_offers.svg": "b73b",
	"./theme4/images/img_plan.svg": "1731",
	"./theme4/images/img_ring.svg": "25c2",
	"./theme4/images/img_upload.svg": "93e8",
	"./theme4/images/img_zh.svg": "7b3e",
	"./theme4/images/letter/img_bell.svg": "1570",
	"./theme4/images/letter/img_ring.svg": "701a",
	"./theme4/images/live_icon.svg": "e01f",
	"./theme4/images/logo/logo.svg": "77da",
	"./theme4/images/lottery_icon.svg": "2fe5",
	"./theme4/images/nav/icon_nav_gift.svg": "f76d",
	"./theme4/images/nav/icon_nav_gift_hover.svg": "8246",
	"./theme4/images/nav/icon_nav_home.svg": "1b2b",
	"./theme4/images/nav/icon_nav_home_hover.svg": "74bf",
	"./theme4/images/nav/icon_nav_more.svg": "7660",
	"./theme4/images/nav/icon_nav_more_hover.svg": "6dfb",
	"./theme4/images/nav/icon_nav_msg.svg": "f891",
	"./theme4/images/nav/icon_nav_msg_hover.svg": "08a8",
	"./theme4/images/nav/icon_nav_topup.svg": "4731",
	"./theme4/images/nav/icon_nav_topup_hover.svg": "d66c",
	"./theme4/images/paker_icon.svg": "2a12",
	"./theme4/images/payment-discount-bg.svg": "8b3c",
	"./theme4/images/pc_header_dark.svg": "9772",
	"./theme4/images/sport_icon.svg": "7aa4",
	"./theme4/images/upload/_img_arrow_right.svg": "fb24",
	"./theme4/images/upload/icon_deposit.svg": "5457",
	"./theme4/images/upload/img_app.svg": "e187",
	"./theme4/images/upload/img_app_download.svg": "9b30",
	"./theme4/images/upload/img_app_download_hover.svg": "91a8",
	"./theme4/images/upload/img_app_hover.svg": "ecd8",
	"./theme4/images/upload/img_arrow_left.svg": "d30e",
	"./theme4/images/upload/img_arrow_right.svg": "bd56",
	"./theme4/images/upload/img_auto-w.svg": "1318",
	"./theme4/images/upload/img_auto.svg": "eb8e",
	"./theme4/images/upload/img_brand_1.svg": "f380",
	"./theme4/images/upload/img_brand_2.svg": "fe40",
	"./theme4/images/upload/img_brand_3.svg": "4b97",
	"./theme4/images/upload/img_brand_hover_1.svg": "66d2",
	"./theme4/images/upload/img_brand_hover_2.svg": "f33c",
	"./theme4/images/upload/img_brand_hover_3.svg": "1df3",
	"./theme4/images/upload/img_chat.svg": "9c55",
	"./theme4/images/upload/img_chat_hover.svg": "144f",
	"./theme4/images/upload/img_crown.svg": "a13f",
	"./theme4/images/upload/img_crown_hover.svg": "7a1d",
	"./theme4/images/upload/img_date.svg": "0bcd",
	"./theme4/images/upload/img_left_nav_bank.svg": "2a57",
	"./theme4/images/upload/img_left_nav_bank_hover.svg": "dac5",
	"./theme4/images/upload/img_left_nav_bet.svg": "6fb9",
	"./theme4/images/upload/img_left_nav_bet_hover.svg": "4610",
	"./theme4/images/upload/img_left_nav_bonus.svg": "b497",
	"./theme4/images/upload/img_left_nav_bonus_hover.svg": "6f87",
	"./theme4/images/upload/img_left_nav_cooperate.svg": "7d65",
	"./theme4/images/upload/img_left_nav_cooperate_hover.svg": "4260",
	"./theme4/images/upload/img_left_nav_detail.svg": "7f80",
	"./theme4/images/upload/img_left_nav_detail_hover.svg": "1f41",
	"./theme4/images/upload/img_left_nav_money.svg": "61bb",
	"./theme4/images/upload/img_left_nav_money_hover.svg": "0d85",
	"./theme4/images/upload/img_left_nav_notify.svg": "6b23",
	"./theme4/images/upload/img_left_nav_notify_hover.svg": "f1c9",
	"./theme4/images/upload/img_left_nav_person.svg": "67c3",
	"./theme4/images/upload/img_left_nav_person_hover.svg": "ffae",
	"./theme4/images/upload/img_left_nav_realtime.svg": "4d75",
	"./theme4/images/upload/img_left_nav_realtime_hover.svg": "a7cd",
	"./theme4/images/upload/img_left_nav_recommend.svg": "2cb6",
	"./theme4/images/upload/img_left_nav_recommend_hover.svg": "f516",
	"./theme4/images/upload/img_left_nav_sale.svg": "c330",
	"./theme4/images/upload/img_left_nav_sale_hover.svg": "f8f4",
	"./theme4/images/upload/img_left_nav_vip.svg": "6f95",
	"./theme4/images/upload/img_left_nav_vip_hover.svg": "2d25",
	"./theme4/images/upload/img_live.svg": "d580",
	"./theme4/images/upload/img_live_hover.svg": "1f08",
	"./theme4/images/upload/img_nav_bank-w.svg": "17da",
	"./theme4/images/upload/img_nav_bank.svg": "b2ec",
	"./theme4/images/upload/img_nav_bank_hover.svg": "30f1",
	"./theme4/images/upload/img_nav_bet-w.svg": "ef5f",
	"./theme4/images/upload/img_nav_bet.svg": "a952",
	"./theme4/images/upload/img_nav_bet_hover.svg": "8823",
	"./theme4/images/upload/img_nav_bonus-w.svg": "3b40",
	"./theme4/images/upload/img_nav_bonus.svg": "c25b",
	"./theme4/images/upload/img_nav_bonus_hover.svg": "31c4",
	"./theme4/images/upload/img_nav_cooperate-w.svg": "a89c",
	"./theme4/images/upload/img_nav_cooperate.svg": "73e8",
	"./theme4/images/upload/img_nav_cooperate_hover.svg": "8123",
	"./theme4/images/upload/img_nav_detail-w.svg": "197d",
	"./theme4/images/upload/img_nav_detail.svg": "ee21",
	"./theme4/images/upload/img_nav_detail_hover.svg": "65c5",
	"./theme4/images/upload/img_nav_lang-w.svg": "6c6c",
	"./theme4/images/upload/img_nav_lang.svg": "63bd",
	"./theme4/images/upload/img_nav_lang_hover.svg": "8508",
	"./theme4/images/upload/img_nav_logout-w.svg": "2478",
	"./theme4/images/upload/img_nav_logout.svg": "b70f",
	"./theme4/images/upload/img_nav_logout_hover.svg": "f4ef",
	"./theme4/images/upload/img_nav_money-w.svg": "2662",
	"./theme4/images/upload/img_nav_money.svg": "9347",
	"./theme4/images/upload/img_nav_money_hover.svg": "d460",
	"./theme4/images/upload/img_nav_notify-w.svg": "bb50",
	"./theme4/images/upload/img_nav_notify.svg": "ffc4",
	"./theme4/images/upload/img_nav_notify_hover.svg": "cb4a",
	"./theme4/images/upload/img_nav_person-w.svg": "dd9d",
	"./theme4/images/upload/img_nav_person.svg": "0bd2",
	"./theme4/images/upload/img_nav_person_hover.svg": "a4a5",
	"./theme4/images/upload/img_nav_realtime-w.svg": "d12a",
	"./theme4/images/upload/img_nav_realtime.svg": "6c89",
	"./theme4/images/upload/img_nav_realtime_hover.svg": "3115",
	"./theme4/images/upload/img_nav_recommend-w.svg": "ca8a",
	"./theme4/images/upload/img_nav_recommend.svg": "bf7e",
	"./theme4/images/upload/img_nav_recommend_hover.svg": "e51c",
	"./theme4/images/upload/img_nav_sale-w.svg": "bb9f",
	"./theme4/images/upload/img_nav_sale.svg": "f704",
	"./theme4/images/upload/img_nav_sale_hover.svg": "17ad",
	"./theme4/images/upload/img_nav_service-w.svg": "db76",
	"./theme4/images/upload/img_nav_service.svg": "7d87",
	"./theme4/images/upload/img_nav_vip-w.svg": "3969",
	"./theme4/images/upload/img_nav_vip.svg": "5ea6",
	"./theme4/images/upload/img_nav_vip_hover.svg": "e50f",
	"./theme4/images/upload/img_plan.svg": "7fae",
	"./theme4/images/upload/img_plan_hover.svg": "5533",
	"./theme4/images/upload/img_quick.svg": "ca07",
	"./theme4/images/upload/img_quick_hover.svg": "c981",
	"./theme4/images/upload/img_realtime.svg": "c65a",
	"./theme4/images/upload/img_realtime_hover.svg": "377d",
	"./theme4/images/upload/img_roll.svg": "ddff",
	"./theme4/images/upload/img_roll_hover.svg": "24ff",
	"./theme4/images/upload/img_sale.svg": "15b7",
	"./theme4/images/upload/img_sale_hover.svg": "cd95",
	"./theme4/images/upload/img_service.svg": "1956",
	"./theme4/images/upload/img_service_hover.svg": "fc36",
	"./theme4/images/upload/img_wallet-w.svg": "6277",
	"./theme4/images/upload/img_wallet.svg": "4dd1",
	"./theme4/images/upload/img_wallet_nav.svg": "591c",
	"./theme4/img/arrow-down.svg": "813a",
	"./theme4/img/arrow-downn.svg": "679e",
	"./theme4/img/arrow-right.svg": "6b50",
	"./theme4/img/chat/basketball_on.svg": "4bb7",
	"./theme4/img/chat/ping-pong_on.svg": "cbbc",
	"./theme4/img/chat/soccer_on.svg": "81a7",
	"./theme4/img/checkbox_checked.svg": "4095",
	"./theme4/img/checkbox_default.svg": "7495",
	"./theme4/img/copy-icon-active.svg": "4db2",
	"./theme4/img/copy-icon.svg": "aa3f",
	"./theme4/img/flow_chat-now.svg": "46bb",
	"./theme4/img/flow_chat-now_hover.svg": "0b82",
	"./theme4/img/flow_customer-service.svg": "97ae",
	"./theme4/img/flow_customer-service_hover.svg": "2390",
	"./theme4/img/flow_get-app.svg": "df2d",
	"./theme4/img/flow_get-app_hover.svg": "e0ab",
	"./theme4/img/header-co.svg": "a384",
	"./theme4/img/header-discount.svg": "df80",
	"./theme4/img/header-rebate.svg": "3015",
	"./theme4/img/header-sto.svg": "3dbb",
	"./theme4/img/header-vip.svg": "548c",
	"./theme4/img/icon_calendar.svg": "9a40",
	"./theme4/img/icon_download.svg": "a998",
	"./theme4/img/icon_play.svg": "1ca4",
	"./theme4/img/index/float-btn-cockfigh.svg": "e195",
	"./theme4/img/index/float-btn-esports.svg": "ad82",
	"./theme4/img/index/float-btn-fish.svg": "4811",
	"./theme4/img/index/float-btn-live.svg": "626f",
	"./theme4/img/index/float-btn-lottery.svg": "42eb",
	"./theme4/img/index/float-btn-poker.svg": "123b",
	"./theme4/img/index/float-btn-slot.svg": "4c30",
	"./theme4/img/index/float-btn-sports.svg": "3173",
	"./theme4/img/mobile/customer-service.svg": "8cf9",
	"./theme4/img/mobile/tabbar/chat_off.svg": "1e1f",
	"./theme4/img/mobile/tabbar/chat_on.svg": "a790",
	"./theme4/img/mobile/tabbar/chat_on_s.svg": "ab1d",
	"./theme4/img/mobile/tabbar/discount_off.svg": "65b3",
	"./theme4/img/mobile/tabbar/discount_on.svg": "50da",
	"./theme4/img/mobile/tabbar/friend_off.svg": "e1d2",
	"./theme4/img/mobile/tabbar/friend_on.svg": "3601",
	"./theme4/img/mobile/tabbar/friend_on_s.svg": "e887",
	"./theme4/img/mobile/tabbar/home_off.svg": "2219",
	"./theme4/img/mobile/tabbar/more_off.svg": "b43e",
	"./theme4/img/mobile/tabbar/more_on.svg": "eb8d",
	"./theme4/img/mobile/tabbar/more_on_s.svg": "0291",
	"./theme4/img/mobile/tabbar/topup_off.svg": "a08a",
	"./theme4/img/mobile/tabbar/topup_on.svg": "9a63",
	"./theme4/img/mobile/tabbar/topup_on_s.svg": "db29",
	"./theme4/img/model_provider_arrow-o.svg": "71dc",
	"./theme4/img/model_provider_arrow.svg": "5559",
	"./theme4/img/notion.svg": "9fd8",
	"./theme4/img/personal_deposit.svg": "d1fe",
	"./theme4/img/provider/arrow_back.svg": "5ea2",
	"./theme4/img/provider/chicken.svg": "38e7",
	"./theme4/img/provider/fishing.svg": "3f35",
	"./theme4/img/provider/live.svg": "21f7",
	"./theme4/img/provider/poker.svg": "d608",
	"./theme4/img/provider/provider_bingo.svg": "ee57",
	"./theme4/img/provider/provider_championship.svg": "9337",
	"./theme4/img/provider/provider_fishing.svg": "e5e6",
	"./theme4/img/provider/provider_new_games.svg": "d704",
	"./theme4/img/provider/provider_poker.svg": "ad94",
	"./theme4/img/provider/provider_providers.svg": "c5d4",
	"./theme4/img/provider/provider_providers_mobile.svg": "f9c1",
	"./theme4/img/provider/provider_slot.svg": "966d",
	"./theme4/img/provider/provider_top.svg": "dfd3",
	"./theme4/img/provider/slot.svg": "83b8",
	"./theme4/img/provider/sports.svg": "6b9a",
	"./theme4/img/provider_arrow.svg": "2b35",
	"./theme4/img/provider_instantwins.svg": "f41b",
	"./theme4/img/provider_jackpot.svg": "da8a",
	"./theme4/img/provider_livecasino.svg": "53da",
	"./theme4/img/provider_newgames.svg": "781d",
	"./theme4/img/provider_search.svg": "de8f",
	"./theme4/img/provider_slots.svg": "57e5",
	"./theme4/img/provider_toprated.svg": "4218",
	"./theme4/img/register_icon__personal.svg": "769a",
	"./theme4/img/register_icon_key.svg": "5078",
	"./theme4/img/shortcut_app_off.svg": "243c",
	"./theme4/img/shortcut_chat_off.svg": "ff72",
	"./theme4/img/shortcut_net_off.svg": "517b",
	"./theme4/img/shortcut_service_off.svg": "d4b4",
	"./theme4/img/shortcut_toff_off.svg": "d8fe",
	"./theme4/img/slide_notic_cal.svg": "098c",
	"./theme4/img/slide_notice_close.svg": "3f6e",
	"./theme4/img/slide_notice_mail.svg": "d9b0",
	"./theme4/img/slide_notice_open.svg": "1ec2",
	"./theme4/img/slide_notice_ser.svg": "2099",
	"./theme4/img/slide_notice_sto.svg": "26120"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "31e8";